exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#notfound[data-v-4014cf97]{text-align:center;padding:12px}", ""]);

// exports
